import { IconButton, LuIcon } from "@overmap-ai/blocks"
import { useRouter } from "@tanstack/react-router"
import { memo, useCallback } from "react"

import { modelIconMapping } from "../../mappings/icons"

export const BackButton = memo(() => {
	const router = useRouter()

	const handleClick = useCallback(() => {
		router.history.back()
	}, [router.history])

	return (
		<IconButton onClick={handleClick} disabled={!router.history.canGoBack()} aria-label="back" variant="ghost">
			<LuIcon icon={modelIconMapping.arrowLeft} />
		</IconButton>
	)
})
BackButton.displayName = "BackButton"
